const API_BASE_URL = String(process.env.VUE_APP_API_BASE_URL || '/api').replace(/\/$/, '')

function normalizeProductFileUrl(path, apiBaseUrl = API_BASE_URL) {
  const value = String(path || '').trim()
  // 文件地址没有图片占位值；拒绝脚本、内联文档及不规范的协议地址。
  if (!value || /^[?#]/.test(value)) return ''
  for (let index = 0; index < value.length; index++) {
    const code = value.charCodeAt(index)
    if (code <= 31 || code === 127 || code === 92) return ''
  }
  if (/^[a-z][a-z\d+.-]*:/i.test(value) && !/^https?:\/\//i.test(value)) return ''
  const base = String(apiBaseUrl || '/api').replace(/\/$/, '')
  if (/^(?:https?:)?\/\//i.test(value)) {
    try {
      const url = new URL(value, 'https://file.invalid')
      const api = new URL(base, 'https://file.invalid')
      const managedPath = url.pathname.indexOf('/uploads/') === 0
        ? url.pathname
        : (url.pathname.indexOf('/api/uploads/') === 0 ? url.pathname.slice(4) : '')
      const localHost = /^(localhost|127\.0\.0\.1|\[::1\])$/i.test(url.hostname)
      // 本站和历史本机上传地址走 API 代理；第三方文件保留原始地址及签名参数。
      if (managedPath && (url.origin === api.origin || localHost)) {
        return base + managedPath + url.search + url.hash
      }
      return value
    } catch (error) {
      return ''
    }
  }
  const relative = '/' + value.replace(/^\//, '')
  if (relative.indexOf('/api/uploads/') === 0) return base + relative.slice(4)
  if (relative.indexOf('/uploads/') === 0) return base + relative
  return relative
}

function isPdfFile(file = {}) {
  return /^(PDF|application\/pdf)(?:\s*;.*)?$/i.test(String(file.fileType || '').trim()) ||
    /\.pdf(?:[?#]|$)/i.test(file.fileUrl || '') || /\.pdf$/i.test(file.fileName || '')
}

function isImageFile(file = {}) {
  if (isPdfFile(file)) return false
  return /^(IMAGE|JPG|JPEG|PNG|GIF|WEBP|BMP|image\/(jpeg|png|gif|webp|bmp))(?:\s*;.*)?$/i.test(String(file.fileType || '').trim()) ||
    /\.(jpg|jpeg|png|gif|webp|bmp)(?:[?#]|$)/i.test(file.fileUrl || '')
}

function normalizeProductFiles(files) {
  return (Array.isArray(files) ? files : []).filter(Boolean).map(file => ({
    ...file,
    fileUrl: normalizeProductFileUrl(file.fileUrl),
    fileName: String(file.fileName || '产品文件').trim() || '产品文件',
    fileType: String(file.fileType || 'FILE').trim() || 'FILE'
  })).filter(file => file.fileUrl)
}

module.exports = { normalizeProductFileUrl, normalizeProductFiles, isPdfFile, isImageFile }
